import React, { useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Platform,
} from "react-native";

import AppTheme from "../AppTheme";
import SwipeablePanel from "../common/SwipeablePanel/index";

export default function MenuEditOptionsPanel({
  isPanelActive,
  close,
  options = [],
  panelStyle={},
}) {
  const [panelProps] = useState({
    fullWidth: true,
    openLarge: false,
    showCloseButton: false,
    noBar: true,
    paddingHorizontal: 20,
    panelColor: "transparent",
    closeOnTouchOutside: true,
    onClose: () => close(),
    onPressCloseButton: () => close(),
    ...panelStyle,
  });

  return (
    <SwipeablePanel {...panelProps} isActive={isPanelActive}>
      <View style={styles.group}>
        {options.map((option, index) => (
          <TouchableOpacity
            key={index}
            onPress={option.action}
            style={[
              styles.button,
              index != options.length - 1 ? styles.underline : {},
            ]}
          >
            <Text
              style={[
                styles.buttonText,
                option.isDelete ? styles.dangerText : {},
              ]}
            >
              {option.text}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      <View
        style={[styles.group, { marginVertical: 6, backgroundColor: "#FFF" }]}
      >
        <TouchableOpacity onPress={close} style={[styles.button]}>
          <Text style={[styles.buttonText, styles.cancel]}>Cancel</Text>
        </TouchableOpacity>
      </View>
    </SwipeablePanel>
  );
}

const styles = StyleSheet.create({
  group: {
    borderRadius: 15,
    backgroundColor: "#ebeaea",
  },
  button: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingVertical: 15,
  },
  dangerText: {
    color: "#FF3B30",
  },
  cancel: {
    color: AppTheme.menuText,
    fontWeight: "600",
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.DEFAULT_COLOR,
  },
  underline: {
    borderBottomWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.4)",
  },
});
